import * as React from 'react';
import { Svg } from '../svg';

function SvgArrowLeftV3({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.41 18.59L14 20l-8-8 8-8 1.41 1.41L8.83 12l6.58 6.59z"
        fill="#fff"
      />
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgArrowLeftV3);
export default ForwardRef;
